import { MouseEventHandler } from "react";
import classNames from "classnames";
import Flag from "react-country-flag";
import Icon from "../Icon";

import styles from "./Dropdown.module.css";

export interface IBaseDropDownItems {
  id: number | string;
  name: string;
  isSelected: boolean;
  disabled?: boolean;
  extraData?: any;
}

export interface IDropdownItemsWithIcons extends IBaseDropDownItems {
  icon?: "check" | "minus" | "x" | "user" | "users";
  color?: "Primary-700" | "Grey-500" | "Error-500";
  onlySelected?: boolean;
}

export interface IDropdownItemsWithFlag extends IBaseDropDownItems {
  flag?: string;
}

export interface IDropdownItem extends IBaseDropDownItems {}

export interface IItemProp
  extends IDropdownItemsWithIcons,
    IDropdownItemsWithFlag,
    IDropdownItem {}

interface DropdownItemProps {
  item: IItemProp;
  focused: boolean;
  withoutCheckIcon?: boolean;
  showTooltip?: boolean;
  onSelectItem(item: IDropdownItem, e: any): void;
  keyHandler: (e: any) => false | undefined;
  onHover?: MouseEventHandler<HTMLElement>;
}

export default function DropdownItem({
  item,
  withoutCheckIcon = false,
  focused,
  onSelectItem,
  keyHandler,
  onHover,
}: Readonly<DropdownItemProps>) {
  const itemClasses = classNames({
    [styles.dropdownItemContainer]: true,
    [styles.selectedItem]: item.isSelected,
    [styles.focused]: focused,
    [styles.disabled]: item.disabled,
  });

  const textClasses = classNames({
    [styles.dropdownItemName]: true,
    [styles.dropdownItemSelectedName]: item.isSelected,
    [styles.dropdownItemDisabledName]: item.disabled,
    [styles.clearItem]: item.id === -1,
  });

  const labelId = `dropdown-${item.id}-label`;

  return (
    <span
      role="option"
      aria-selected={item.isSelected}
      tabIndex={0}
      className={`${itemClasses} option`}
      onClick={(e) => onSelectItem(item, e)}
      onKeyDown={keyHandler}
      aria-labelledby={labelId}
      data-cy="dropDownOption"
      onMouseMove={onHover}
    >
      {/* onlySelected field prevents showing icons in the dropdown but shows 
          it on the currently selected one in the dropdown button */}
      {item.icon && !item.onlySelected && (
        <Icon name={item.icon} color={item.color} />
      )}

      {item.flag && (
        <Flag svg countryCode={item.flag} className={styles.dropdownFlag} />
      )}
      <span id={labelId} className={textClasses}>
        {item.name}
      </span>
      {item.isSelected && !withoutCheckIcon && (
        <Icon name="check" color="Success-800" />
      )}
    </span>
  );
}
